import { useEffect, useState } from "react";
import Cookies from "js-cookie";

/** Mode client / admin — synchronisé avec App (sans rechargement de page). */
function useViewMode() {
  const [viewMode, setViewMode] = useState(
    () => Cookies.get("viewMode") || "client",
  );

  useEffect(() => {
    const handler = (event) => {
      const next =
        event?.detail?.viewMode || Cookies.get("viewMode") || "client";
      setViewMode(next);
    };
    window.addEventListener("viewModeChanged", handler);
    return () => window.removeEventListener("viewModeChanged", handler);
  }, []);

  return viewMode;
}

export function useIsAdminViewMode() {
  const viewMode = useViewMode();
  const isAkanthasAccount = (Cookies.get("userEmail") || "").includes(
    "@akanthas.com",
  );
  return isAkanthasAccount && viewMode === "admin";
}
